import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {ChangePasswordDTO, HttpService, ResponseDTO} from '@/shared';

@Service()
export class AcountService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async changePassword(
    changePasswordDTO: ChangePasswordDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(changePasswordDTO);
  }
}
